import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * use this function scroll page bottom to top
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    document.getElementById("navbar-fixed").style.top = "0";
    // eslint-disable-next-line
  }, [pathname]);

  return null;
};

export default ScrollToTop;
